import React from 'react';
import {
  validateNotEmpty,
  validateNumber,
  validateMaxLen,
  validateMinLen,
  validateEmail,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';

export const minNumberValidator = (
  minNumber,
  errorMessage = {},
  isFloat = false
) => ({
  validator: (value) => {
    const parser = isFloat ? parseFloat : parseInt;

    return parser(value, 10) >= minNumber ? 'success' : 'error';
  },
  errorMessage: (
    <Message
      message={{
        ...errorMessage,
        values: { value: minNumber },
      }}
    />
  ),
});

export const maxNumberValidator = (
  maxNumber,
  errorMessage = {},
  isFloat = false
) => ({
  validator: (value) => {
    const parser = isFloat ? parseFloat : parseInt;

    return parser(value, 10) <= maxNumber ? 'success' : 'error';
  },
  errorMessage: (
    <Message
      message={{
        ...errorMessage,
        values: { value: maxNumber },
      }}
    />
  ),
});

export const specialCharValidator = (errorMessage = {}) => ({
  validator: (value) => (/[^/",~'\\?]$/.test(value) ? 'success' : 'error'),
  errorMessage: <Message message={errorMessage} />,
});

export const primerNameSpecialCharValidator = (errorMessage = {}) => ({
  validator: (value) => (/[^/",~'\\]$/.test(value) ? 'success' : 'error'),
  errorMessage: <Message message={errorMessage} />,
});

export const startsWithSpaceValidator = (errorMessage = {}) => ({
  validator: (value) => (/^\s*$/.test(value) ? 'error' : 'success'),
  errorMessage: <Message message={errorMessage} />,
});

export const nonEmptyValidator = (errorMessage = {}) => ({
  validator: validateNotEmpty,
  errorMessage: <Message message={errorMessage} />,
});

export const numberOnlyValidator = (errorMessage = {}) => ({
  validator: validateNumber,
  errorMessage: <Message message={errorMessage} />,
});

export const emailOnlyValidator = (errorMessage = {}) => ({
  validator: (value) => validateEmail(value),
  errorMessage: <Message message={errorMessage} />,
});

export const maxLenValidator = (maxLen, errorMessage = {}) => ({
  validator: (value) => validateMaxLen(value, maxLen),
  errorMessage: <Message message={errorMessage} />,
});

export const minLenValidator = (minLen, errorMessage = {}) => ({
  validator: (value) => validateMinLen(value, minLen),
  errorMessage: <Message message={errorMessage} />,
});

export const positiveNumberValidator = (errorMessage = {}) => ({
  validator: (value) => value >= 0 ? 'success' : 'error',
  errorMessage: (
    <Message message={errorMessage} />
  ),
});
